export const ScreenImage = require('./screen.png');
export const WebAppImage = require('./webApp.png');
export const MobileAppImage = require('./mobileApp.png');
